import { datasource } from "./datasource";

export const salesPersonDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("sales_person", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        user_id: {
          type: "string",
        },
        name: {
          type: "string",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
      },
    },
  });
